/**
 * Fonctions utilitaires pour le formatage des dates.
 */

/**
 * Formate une date ISO en format français JJ/MM/AAAA.
 * @param {string|null} dateStr - Date au format ISO (YYYY-MM-DD).
 * @returns {string} Date formatée ou chaîne vide.
 */
export function formatDate(dateStr) {
  if (!dateStr) return "";
  const date = new Date(dateStr + "T00:00:00");
  const day = String(date.getDate()).padStart(2, "0");
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const year = date.getFullYear();
  return `${day}/${month}/${year}`;
}

/**
 * Vérifie si une date est dépassée par rapport à aujourd'hui.
 * @param {string|null} dateStr - Date au format ISO.
 * @returns {boolean} True si la date est dans le passé.
 */
export function isOverdue(dateStr) {
  if (!dateStr) return false;
  const today = new Date();
  today.setHours(0, 0, 0, 0);
  const target = new Date(dateStr + "T00:00:00");
  return target < today;
}

/**
 * Retourne la date du jour au format ISO (YYYY-MM-DD).
 * @returns {string} Date du jour.
 */
export function todayISO() {
  return new Date().toISOString().split("T")[0];
}
